// Картка товару — FancyBox каруселі та лайтбокс

(function (Drupal, once) {
  Drupal.behaviors.productQuantity = {
    attach: function (context) {
      once("fbox-init", "html").forEach(function () {
        if (typeof Carousel === "undefined" || typeof Fancybox === "undefined") {
          console.warn("Fancybox libraries not loaded");
          return;
        }

        const container = document.getElementById("fbox__prod-card");
        if (!container) return;

        try {
          const carousel = new Carousel(
            container,
            {
              Dots: false,
              Thumbs: { type: "classic" },
              center: false,
              on: {
                ready: (instance) => {
                  /* Перенести стрілки навігації в блок тамбнейлів */
                  const nav = instance.container.querySelector(".f-carousel__nav");
                  const thumbs = instance.container
                    .closest(".fbox-container")
                    ?.querySelector(".f-thumbs");
                  if (nav && thumbs) {
                    thumbs.appendChild(nav);
                    /* Прив'язати кнопки до головної каруселі */
                    nav.querySelector("[data-carousel-prev]")?.addEventListener("click", (e) => {
                      e.stopPropagation();
                      instance.slidePrev();
                    });
                    nav.querySelector("[data-carousel-next]")?.addEventListener("click", (e) => {
                      e.stopPropagation();
                      instance.slideNext();
                    });
                  }
                },
              },
            },
            { Thumbs },
          );
          Fancybox.bind('[data-fancybox="gallery"]', {
            Thumbs: { type: "classic" },
          });
        } catch (error) {
          console.warn("Fancybox initialization error:", error);
        }
      });
    },
  };
})(Drupal, once);
